// extracted by mini-css-extract-plugin
export default {"nav":"BottomNav_nav__7sUEm","item":"BottomNav_item__op+oL","active":"BottomNav_active__4l86U","icon":"BottomNav_icon__mFalw"};